import React from 'react';
import { HeroSection } from '../components/HeroSection';
import { FamiliarSection } from '../components/FamiliarSection';
import { IdentificationSection } from '../components/IdentificationSection';
import { MechanismSection } from '../components/MechanismSection';
import { WhyNothingWorksSection } from '../components/WhyNothingWorksSection';
import { MethodSection } from '../components/MethodSection';
import { WhatChangesSection } from '../components/WhatChangesSection';
import { ObjectionsSection } from '../components/ObjectionsSection';
import { FinalOfferSection } from '../components/FinalOfferSection';
export function LandingPage() {
  return <main className="w-full" data-id="element-247">
      <HeroSection data-id="element-248" />
      <FamiliarSection data-id="element-249" />
      <IdentificationSection data-id="element-250" />
      <MechanismSection data-id="element-251" />
      <WhyNothingWorksSection data-id="element-252" />
      <MethodSection data-id="element-253" />
      <WhatChangesSection data-id="element-254" />
      <ObjectionsSection data-id="element-255" />
      <FinalOfferSection data-id="element-256" />
    </main>;
}